'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwFlexbox = require('./CwFlexbox.scss');

var _CwFlexbox2 = _interopRequireDefault(_CwFlexbox);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Enums = require('../../utils/Enums');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwFlexbox = function CwFlexbox(props) {
  var _cx;

  return _react2.default.createElement(
    'div',
    {
      'data-cwid': props.cwId,
      onClick: props.onClick,
      style: props.style,
      className: (0, _classnames2.default)(_CwFlexbox2.default.wrap, props.className, (_cx = {}, (0, _defineProperty3.default)(_cx, _CwFlexbox2.default.column, props.column), (0, _defineProperty3.default)(_cx, _CwFlexbox2.default.verticalAlign, props.verticalAlign), (0, _defineProperty3.default)(_cx, _CwFlexbox2.default.horizontalAlign, props.horizontalAlign), (0, _defineProperty3.default)(_cx, _CwFlexbox2.default.leftAlign, props.align === _Enums.AlignmentEnum.LEFT), (0, _defineProperty3.default)(_cx, _CwFlexbox2.default.centerAlign, props.align === _Enums.AlignmentEnum.CENTER), (0, _defineProperty3.default)(_cx, _CwFlexbox2.default.rightAlign, props.align === _Enums.AlignmentEnum.RIGHT), _cx)) },
    props.children
  );
};

CwFlexbox.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  column: _propTypes2.default.bool,
  verticalAlign: _propTypes2.default.bool,
  horizontalAlign: _propTypes2.default.bool,
  align: _propTypes2.default.oneOf([_Enums.AlignmentEnum.LEFT, _Enums.AlignmentEnum.CENTER, _Enums.AlignmentEnum.RIGHT]),
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

exports.default = CwFlexbox;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwflexbox/CwFlexbox.js
// module id = 226
// module chunks = 10